/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pano_person': {
    width: 16,
    height: 16,
    viewBox: '0 0 234.24 213.79',
    data: '<path pid="0" d="M202.3 102.07v23.89c6.92 4.5 10.64 9.19 10.64 13.3 0 10.46-24.1 24.7-63.88 29.91v21.37c45.37-5.61 85.18-23.19 85.18-51.28 0-15.84-12.72-28.3-31.94-37.19zM95.82 149.9v20.43c-46.1-3.86-74.53-19.7-74.53-31.07 0-4.11 3.73-8.8 10.65-13.3v-23.89C12.75 110.96 0 123.42 0 139.26c0 30.27 46.22 48.33 95.82 52.38v22.15l32-31.94z"/><path pid="1" d="M66.06 136.15c0-31.33 19.73-51.06 51.06-51.06 31.32 0 51.06 19.73 51.06 51.06z"/><circle pid="2" cx="117.12" cy="34.04" r="34.04"/>'
  }
})
